import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import { gridNumberFormatter, formattedNumberValueGetter } from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { CITY_VIDEO_REPORT_ID } from './cityVideoReportId';

const cityReportColumnDefinition = [
    {
        headerName: FIELDS.CITY.label,
        field: FIELDS.CITY.field,
        type: [leftPinnedColumn],
        cellRenderer: FIELDS.CITY.cellRenderer,
        cellRendererParams: FIELDS.CITY.renderParams,
        csvValueGetter: FIELDS.CITY.csvValueGetter,
    },
    ...[
        FIELDS.SPENT,
        FIELDS.VIDEO_VCTR,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.CLICKS,
        FIELDS.AVERAGE_CPC,
        FIELDS.VIDEO_CVR,
        FIELDS.CONVERSIONS,
        FIELDS.CPA,
        FIELDS.VIDEO_VCPM,
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.VIDEO_CPM,
        FIELDS.VIDEO_CTR,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.ROAS,

        FIELDS.COMPLETED_VIEWS,
        FIELDS.CPCV,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(cityReportColumnDefinition, CITY_VIDEO_REPORT_ID);
